module.exports = __webpack_public_path__ + "img/icon_dashboard_blockstorage1.01651e3f.svg";